@switch (ansicht()) {
  @case ('laeuft') {
    <app-ki-laeuft [aktion]="'ki.qualitaet.laeuft' | translate" />
  }
  @case ('ergebnis') {
    <div class="ki-qualitaet__ergebnis" role="status">
      <app-ki-badge [label]="'ki.qualitaet.badge' | translate" />
      <span class="ki-qualitaet__anzahl" data-testid="ki-qualitaet-anzahl">
        @if (zaehler(); as z) {
          @if (z.gefunden === 0) {
            {{ 'ki.qualitaet.keineBefunde' | translate }}
          } @else if (z.anzahl === 0) {
            {{ 'ki.qualitaet.keineOffenen' | translate }}
          } @else if (z.offen === 0) {
            {{
              (z.anzahl === 1 ? 'ki.qualitaet.einerBearbeitet' : 'ki.qualitaet.alleBearbeitet')
                | translate: { anzahl: z.anzahl }
            }}
          } @else {
            {{
              (z.anzahl === 1 ? 'ki.qualitaet.offenEins' : 'ki.qualitaet.offen')
                | translate: { offen: z.offen, anzahl: z.anzahl }
            }}
          }
        }
      </span>
      @if (!readOnly()) {
        <button
          type="button"
          class="ki-qualitaet__textknopf"
          data-testid="ki-qualitaet-erneut"
          [disabled]="!!sperrgrund()"
          (click)="pruefen()"
        >
          {{ 'ki.qualitaet.erneutPruefen' | translate }}
        </button>
      }
      <button
        type="button"
        class="ki-qualitaet__textknopf"
        data-testid="ki-qualitaet-schliessen"
        (click)="schliessen()"
      >
        {{ 'ki.panel.schliessen' | translate }}
      </button>
    </div>
    @for (eintrag of befundeUnterLeiste(); track eintrag.key) {
      <app-ki-befund-inline
        [befund]="eintrag.anzeige"
        [aktuell]="aktuellerWert(eintrag.anzeige)"
        [readOnly]="readOnly()"
        (uebernehmen)="unterLeisteErledigt(eintrag.key, true)"
        (lassen)="unterLeisteErledigt(eintrag.key, false)"
      />
    }
    @if (gesendet(); as gesendet) {
      <app-ki-gesendet class="ki-qualitaet__gesendet" [gesendet]="gesendet" />
    }
  }
  @default {
    <div class="ki-qualitaet__leiste" data-testid="ki-qualitaet-leiste">
      <app-ki-mark [size]="22" />
      <span class="ki-qualitaet__leiste-text">
        <span class="ki-qualitaet__leiste-titel">{{ 'ki.qualitaet.titel' | translate }}</span>
        <span class="ki-qualitaet__leiste-untertitel">{{ 'ki.qualitaet.untertitel' | translate }}</span>
      </span>
      <app-ki-button
        funktion="TESTDESIGN"
        [label]="'ki.qualitaet.pruefen' | translate"
        [state]="buttonZustand().state"
        [sperrgrund]="buttonZustand().sperrgrund"
        (ausloesen)="pruefen()"
      />
    </div>
    @if (abgelaufen()) {
      <app-ki-ergebnis-abgelaufen class="ki-qualitaet__fehler" />
    }
    @if (fehlerKey(); as fehlerKey) {
      <app-ki-fehler class="ki-qualitaet__fehler" [text]="fehlerKey | translate" (erneut)="pruefen()" />
    }
  }
}

@if (run.hinweis(); as verbindung) {
  <app-ki-erste-nutzung
    [verbindung]="verbindung"
    (verstanden)="run.hinweisVerstanden()"
    (abgebrochen)="run.hinweisAbgebrochen()"
  />
}
